// extracted by mini-css-extract-plugin
export default {"form":"MoveModalForm-module__form--LS8Xy","autoComplete":"MoveModalForm-module__autoComplete--r2LJ6"};